import React from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBInput,
  MDBIcon,
  MDBModalHeader,
  MDBModalBody,
  MDBModal,
} from "mdbreact";
import { Authcontext } from "../context/Authcontext";
import { BookContext } from "../context/BookContext";
import { useState, useEffect, useContext } from "react";
const LentForm = ({ toggle, modal, bookId }) => {
  const { lendBook } = useContext(BookContext);
  const [Name, setName] = useState("");
  const [Date, setDate] = useState("");
  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };
  const handleOnSubmit = (e) => {
    console.log("inside submit");
    e.preventDefault();

    const details = {
      name: Name,
      date: Date,
      lent: true,
    };
    lendBook(bookId, details);
    setDate("");
    setName("");
    toggle()
  };
  return (
    <MDBContainer>
      <MDBModal isOpen={modal} toggle={toggle}>
        <MDBModalHeader toggle={toggle}>Lent Details</MDBModalHeader>

        <MDBModalBody>
          <form
            onSubmit={handleOnSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
              <MDBInput
                label="Name of borower"
                type="text"
                onChange={handleNameChange}
                value={Name} 
              />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                padding: "20px 10px",
              }}
            >
              {" "}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <MDBIcon icon="dot-circle" style={{ paddingRight: "10px" }} />{" "}
                <h5> Lent on:</h5>
              </div>
              <input
                icon="calendar-alt"
                type="date"
                onChange={handleDateChange}
                value={Date}
              />
            </div>
            <input
              type="submit"
              value="submit"
              style={{
                marginTop: "20px",
                backgroundColor: "#c51162",
                color: "white",
                padding: "10px 20px",
                borderRadius: "20px",
              }}
            />{" "}
          </form>
        </MDBModalBody>
      </MDBModal>
    </MDBContainer>
  );
};
export default LentForm;
